import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import RichText from '../ui/RichText';
import '../../css/common/FAQCard.css';

const FAQCard = ({ faq }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleClick = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <div className="faq-card-component" onClick={handleClick}>
      <div className={`faq-card-inner ${isFlipped ? 'flipped' : ''}`}>
        <div className="faq-card-front">
          <div className="faq-card-content">
            <h3 className="faq-question">{faq.question}</h3>
            <div className="faq-card-icon">
              <FaChevronDown />
            </div>
          </div>
        </div>

        <div className="faq-card-back">
          <div className="faq-card-content">
            <div className="faq-answer">
              <RichText value={faq.answer} />
            </div>
            <div className="faq-card-icon">
              <FaChevronUp />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQCard;
